import Panel from './Panel'
import Pill from './Pill'
import FlatTextClickable from './FlatTextClickable'

export default function NavPanel({ pages, pageIndex, setPageIndex }) {
  const fontSize = 0.07
  const lineHeight = 2
  const totalTabsHeight = fontSize * 2 * pages.length

  const clickCallback = (e) => setPageIndex(e.object.userData.index)

  return (
    <>
      <Panel size={[0.65, totalTabsHeight + 0.1]}></Panel>

      {pages.map((page, i) => (
        <group key={`pill-${i}`}>
          <Pill
            width={0.6}
            height={fontSize * 2}
            position={[0, -(fontSize * 2 * i) + totalTabsHeight * 0.5 - 0.1, 0.002]}
          />
          <FlatTextClickable
            renderOrder={10}
            pageIndex={pageIndex}
            clickCallback={clickCallback}
            children={page.title}
            userData={{ index: i }}
            position={[0, -(fontSize * 2 * i) + totalTabsHeight * 0.5 - 0.1, 0.003]}
            fontSize={fontSize}
            lineHeight={lineHeight}
            letterSpacing={-0.05}
            maxWidth={0.6}
            overflowWrap={'break-word'}
            textAlign={'center'}
            anchorX={'center'}
            anchorY={'middle'}
            materialToneMapped={false}
          />
        </group>
      ))}
    </>
  )
}
